import { addDays, differenceInHours, isAfter, isBefore } from 'date-fns'
import { makeAutoObservable } from 'mobx'
import { remoteStorageService } from 'src/utils/axios/remoteStorage'

export default class PageTemplateService {
  isSideNavigationOpen = false

  achievementAnalysisBanner = {
    isVisible: false,
    hideBanner: () => {
      this.achievementAnalysisBanner.isVisible = false
      remoteStorageService.patch(
        'PREVIOUS_ACHIEVEMENT_ANALYSIS_BANNER_CLOSED_MS',
        new Date().getTime(),
      )
    },
  }

  myDBLuckyWeekBanner = {
    isVisible: false,
    hideBanner: () => {
      this.myDBLuckyWeekBanner.isVisible = false
      remoteStorageService.patch('MY_DB_LUCKY_WEEK_BANNER_CLOSED', new Date().getTime())
    },
  }

  constructor() {
    makeAutoObservable(this)

    remoteStorageService.get('MY_DB_LUCKY_WEEK_BANNER_CLOSED').then((data) => {
      if (isAfter(new Date(), new Date('2026-05-27'))) return

      const closedAt = data?.MY_DB_LUCKY_WEEK_BANNER_CLOSED

      // 닫은 적 없거나(null), 닫은 지 24시간 이상 경과하면 재노출
      // 로그아웃 시 onLogout에서 null로 초기화되므로 재로그인 시 무조건 재노출
      this.myDBLuckyWeekBanner.isVisible =
        !closedAt || differenceInHours(new Date(), new Date(closedAt)) >= 24
    })

    remoteStorageService.get('PREVIOUS_ACHIEVEMENT_ANALYSIS_BANNER_CLOSED_MS').then((data) => {
      const perviousBannerClosedMS = data?.PREVIOUS_ACHIEVEMENT_ANALYSIS_BANNER_CLOSED_MS

      if (perviousBannerClosedMS) {
        const perviousBannerClosedTime = new Date(perviousBannerClosedMS)

        // 마지막 배너 비노출 시점이 24시간 전이며, 현재가 정오를 지났을 경우 재노출
        this.achievementAnalysisBanner.isVisible = isBefore(
          addDays(perviousBannerClosedTime, 1),
          new Date(),
        )

        return
      }

      this.achievementAnalysisBanner.isVisible = true
    })
  }

  setSideNavigationOpen(isOpen: boolean) {
    this.isSideNavigationOpen = isOpen
  }
}
